import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AuthCard from './AuthCard';

const POINTS = [
    {
        title: 'Un gran poder, conlleva una gran responsabilidad',
        body: 'Tus Créditos para pujar son ilimitados, ¡pujá lo que quieras! Pero si ganás, te comprometés a pagarle a la tienda el monto de tu puja en pesos MXN.',
    },
    {
        title: 'Mi barrio me respalda',
        body: 'Fotos, descripción, precio inicial y hora de cierre son responsabilidad de la tienda que publica el artículo, no nuestra.',
    },
    {
        title: 'Solo territorio TCG',
        body: 'Nada de usos raros o ilegales, ni cosas fuera del mundo TCG. Si pasa, la cuenta se suspende. Así de simple.',
    },
    {
        title: '¿Te gusta PlayBid?',
        body: 'La plataforma es 100% gratis. Si querés apoyarnos, podés comprar algún cosmético con gemas, ¡nunca es obligatorio!',
    },
];

function PrivacySummaryStep({ onAccept, busy, error }) {
    const [checked, setChecked] = useState(() => POINTS.map(() => false));

    const allChecked = checked.every(Boolean);

    const toggle = (index) => (e) => {
        const next = [...checked];
        next[index] = e.target.checked;
        setChecked(next);
    };

    return (
        <AuthCard sx={{ maxWidth: 480 }}>
            <Typography variant="h6" gutterBottom>
                Antes de arrancar
            </Typography>
            <Typography variant="body2" color="rgba(255,255,255,0.7)" sx={{ mb: 3 }}>
                Un resumen rapidito de las reglas más importantes. Marcá cada punto para confirmar
                que las leíste.
            </Typography>
            <Stack spacing={2}>
                {POINTS.map((point, index) => (
                    <FormControlLabel
                        key={point.title}
                        sx={{ alignItems: 'flex-start', ml: 0 }}
                        control={
                            <Checkbox
                                checked={checked[index]}
                                onChange={toggle(index)}
                                sx={{ mt: -0.5 }}
                            />
                        }
                        label={
                            <Box sx={{ mb: 0.5 }}>
                                <Typography variant="subtitle2">{point.title}</Typography>
                                <Typography variant="body2" color="rgba(255,255,255,0.7)">
                                    {point.body}
                                </Typography>
                            </Box>
                        }
                    />
                ))}
                <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    disabled={!allChecked || busy}
                    onClick={onAccept}
                >
                    Aceptar y continuar
                </Button>
                {error && <Alert severity="error">{error}</Alert>}
            </Stack>
        </AuthCard>
    );
}

export default PrivacySummaryStep;
